import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext();

/**
 * Read the saved session synchronously. If the role were only filled in after the first render,
 * ProtectedRoute would see a token with role "public" on a page refresh and bounce /admin to /.
 */
function readSession() {
  try {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (token && user && user.role) return { token, user };
  } catch (e) {
    // fall through to clearing a broken session
  }
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  return { token: null, user: null };
}

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(readSession);
  const { token, user: currentUser } = session;
  const role = currentUser?.role || 'public'; // 'public', 'admin', 'reseller'

  const login = (newToken, userObj) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userObj));
    setSession({ token: newToken, user: userObj });
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setSession({ token: null, user: null });
  };

  return (
    <AuthContext.Provider value={{ currentUser, role, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
